// Issue permit actions
export const ISSUE_PERMIT = 'ISSUE_PERMIT';
export const ISSUE_PERMIT_SUCCESS = 'ISSUE_PERMIT_SUCCESS';
export const ISSUE_PERMIT_ERROR = 'ISSUE_PERMIT_ERROR';

// Get permits by student
export const GET_PERMITS_BY_STUDENT = 'GET_PERMITS_BY_STUDENT';
export const GET_PERMITS_BY_STUDENT_SUCCESS = 'GET_PERMITS_BY_STUDENT_SUCCESS';
export const GET_PERMITS_BY_STUDENT_ERROR = 'GET_PERMITS_BY_STUDENT_ERROR';

